module.exports = __webpack_public_path__ + "img/empty-file.c44911cf.svg";